import { Reveal, Overline } from "./Reveal";

const CHAPTERS = [
  {
    no: "01",
    title: "Fabric Comes First",
    body: "Every outfit begins with the cloth. We pick soft silks, breathable linens and finely woven velvets — chosen for how they feel, move and last.",
  },
  {
    no: "02",
    title: "Two Ways To Wear",
    body: "Pick a ready-made kurta from our collection, or ask us to make one custom-fitted just for you. Same care, your choice.",
  },
  {
    no: "03",
    title: "Made Just For You",
    body: "Our tailors shape your measurements into a kurta that fits perfectly — mandarin collars, clean hems, structured shoulders. Comfortable to wear, truly yours.",
  },
];

export default function Manifesto() {
  return (
    <section id="about" data-testid="manifesto" className="bg-cream py-24 md:py-36">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <Reveal>
          <Overline>Why TOGA</Overline>
          <h2 className="mt-5 font-display font-black uppercase tracking-normal text-charcoal text-4xl md:text-6xl lg:text-7xl max-w-4xl leading-[0.95]">
            Made with <span className="text-toga">care</span>, made for you.
          </h2>
        </Reveal>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-px bg-charcoal/15 border border-charcoal/15">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.no} delay={i * 0.12}>
              <div className="bg-cream p-10 md:p-12 h-full flex flex-col">
                <span className="font-display font-black text-toga text-6xl md:text-7xl">{c.no}</span>
                <h3 className="mt-8 font-display uppercase tracking-tight text-charcoal text-2xl font-bold">{c.title}</h3>
                <p className="mt-5 font-light text-charcoal/70 leading-relaxed">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
